<template>
    <div class="animated fadeIn">
        <b-card >
            <template v-slot:header>
                <h5>Approval Keringanan</h5>
            </template>
            <div class="search-wrapper d-flex align-items-center justify-content-between">
                <b-form-group
                    label="Filter" 
                    label-for="filterInput"
                    class="form-inline form-group-wrapper mb-3"
                >
                    <div class="d-flex search-input-wrapper">
                        <b-form-input class="ml-2 mr-2" 
                            v-model="input.filterNoFaktur" name="filterNoFaktur"
                            id="filterInput"
                            type="search"
                            placeholder="Masukkan no. faktur"
                        >
                        </b-form-input>
                        <b-form-input class="mr-2" 
                            v-model="input.filterNoAnggota" name="filterNoAnggota"
                            type="search"
                            placeholder="No. Anggota"
                        >
                        </b-form-input>
                        <b-form-select class="mr-2" v-model="input.filterStatus" name="statusKeringanan" :options="statusKeringanan" value-field="id" text-field="name">
                            <template v-slot:first>
                                <b-form-select-option :value="null" disabled>-- Pilih Status --</b-form-select-option>
                            </template>
                        </b-form-select>
                        <b-button class="mr-2" variant="pgiBtn" name="searchTableBtn" :disabled="isBusy" @click="onFilter"> 
                            <i class="fa fa-search"></i>
                        </b-button>
                        <b-button variant="pgiBtn" name="resetTableBtn" :disabled="isBusy" @click="onReset">Reset</b-button>
                    </div>
                </b-form-group>
            </div>
            <b-table bordered hover show-empty
                :busy="isBusy"
                :items="dataKeringanan" 
                :fields="fields"
                :no-local-sorting="false"
                @sort-changed="sortingChanged" 
                responsive class="mb-3">
                <template v-slot:table-busy>
                    <div class="text-center text-danger my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>  Loading data...</strong>
                    </div>
                </template>
                <template v-slot:empty>
                    Tidak ada data approval keringanan.
                </template>
                <template v-slot:cell(anggota)="row">
                    <p class="mb-0">{{row.item.namaAnggota}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.noAnggota}}</p>
                </template>
                <template v-slot:cell(barang)="row">
                    <p class="mb-0">{{row.item.jenisBarang}}</p>
                    <p class="mb-0 smallText text-muted">{{row.item.merkBarang}} - {{row.item.tipeBarang}}</p>
                </template>
                <template v-slot:cell(tanggalRequest)="row">
                    <p class="mb-0">{{$helper.changeDateFormat(row.item.tanggalRequest)}}</p>
                    <p class="mb-0 smallText text-muted">{{$helper.changeDateFormatGetHour(row.item.tanggalRequest)}}</p>
                </template>
                <template v-slot:cell(status)="row">
                    <b-badge variant="dark" v-if="row.item.status == 0">DIAJUKAN</b-badge>
                    <b-badge variant="success" v-else-if="row.item.status == 1">DITERIMA</b-badge>
                    <b-badge variant="danger" v-else-if="row.item.status == 2">DITOLAK</b-badge>
                    <b-badge variant="primary" v-else-if="row.item.status == 3">DIGUNAKAN</b-badge>
                    <b-badge v-else>UNKNOWN</b-badge>
                </template>
                <template v-slot:head(status)>
                    Status 
                    <i class="fa fa-question tooltip-trigger-btn ml-1" @click="$bvModal.show('modal-info-status')"/>
                </template>
                <template v-slot:cell(action)="row">
                    <div class="no-wrap">
                        <b-link :to="`${$route.path}/${row.item.id}/${row.item.noFaktur}`">
                            <b-button size="sm" class="table-button view" v-b-tooltip.hover title="Detail" name="keringananViewBtn">
                                <i class="fa fa-info"></i>
                            </b-button>
                        </b-link>
                    </div>
                </template>
            </b-table>
            <div class="pagination-wrapper d-flex align-items-center justify-content-between">
                <b-input-group prepend="Tampilkan" class="align-items-center tableShowItem">
                    <b-form-select v-model="input.show" id="showItems" :options="options" @change="onLimitChange">
                        <template v-slot:first>
                            <b-form-select-option :value="null" disabled />
                        </template>
                    </b-form-select>
                    <span class="ml-2">{{ totalViewText }}</span>
                </b-input-group>
                <b-pagination class="mb-0"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                @input="onPageChange"
                ></b-pagination>
            </div>
        </b-card>
        <b-modal id="modal-info-status" title="Info Status" no-close-on-backdrop>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DIAJUKAN</h6>
                <p class="smallText mb-0">Permohonan keringanan masih menunggu proses dari HO.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITERIMA</h6>
                <p class="smallText mb-0">Permohonan keringanan disetujui oleh HO. Keringanan akan diberlakukan untuk pembayaran selanjutnya.</p>
            </div>
            <div class="detail-data-wrapper mb-3">
                <h6 class="form-title mb-1">DITOLAK</h6>
                <p class="smallText mb-0">Permohonan keringanan ditolak oleh HO. Keringanan tidak dapat digunakan.</p>
            </div>
            <div class="detail-data-wrapper mb-0">
                <h6 class="form-title mb-1">DIGUNAKAN</h6>
                <p class="smallText mb-0">Keringanan telah digunakan oleh salah satu pembayaran nomor faktur tersebut.</p>
            </div>
            <template v-slot:modal-footer="{ cancel }">
                <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
                    Tutup
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'approval-keringanan',
    data(){
        return{
            initStatus: 0,
            isBusy: true,
            input: {
                show: 10,
                filterNoFaktur: null,
                filterNoAnggota: null,
                filterStatus: null
            },
            fields: [
                { key: "noFaktur", label: "No. Faktur" },
                { key: "anggota", label: "Anggota" },
                { key: "cabang", label: "Cabang" },
                { key: "barang", label: "Barang" },
                { key: "tanggalRequest", label: "Tanggal Pengajuan", sortable:true},
                { key: "status", label: "Status" },
                { key: "action", label: "Aksi"},
            ],
            dataKeringanan: [],
            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],
            statusKeringanan: [
                { id: 0, name: 'DIAJUKAN' },
                { id: 1, name: 'DITERIMA' },
                { id: 2, name: 'DITOLAK' },
                { id: 3, name: 'DIGUNAKAN' }
            ],
            currentPage: 1,
            perPage: 10,
            rows: null,
            totalViewText: "",
            page: '',
            size: '',
            loading: false,
            query: ""
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.page = 0
            this.size = this.input.show
            this.query = this.$helper.makeQuery(this.page, this.size)

            let getDataKeringanan = this.$axios.get("gadai-keringanan-pembayaran/"+this.query).then(response => {
                this.dataKeringanan = response.data.data
                this.updateTotalItem(response.data.total)
            })
            
            Promise.all([getDataKeringanan]).then(() => {
                this.initStatus = 1
                this.toggleBusy()
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },


        //----------------- Fungsi Ambil Data Merk -----------------

        getDataKeringanan(){
            this.toggleBusy()
            this.dataKeringanan = []

            if(this.input.filterNoFaktur != null) this.query = this.query + "&filterNoFaktur=" + this.input.filterNoFaktur
            if(this.input.filterNoAnggota != null) this.query = this.query + "&filterNoAnggota=" + this.input.filterNoAnggota
            if(this.input.filterStatus != null) this.query = this.query + "&filterStatus=" + this.input.filterStatus
            if(this.input.sortBy != null) this.query = this.query + "&sortBy=" + this.input.sortBy
            if(this.input.sortDesc != null) this.query = this.query + "&sortDesc=" + this.input.sortDesc

            this.$axios.get("gadai-keringanan-pembayaran/"+this.query).then(response => {
                this.dataKeringanan = response.data.data
                this.toggleBusy()
                this.updateTotalItem(response.data.total)
                this.loading = false
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$helper.parseError(this, error)
                this.toggleBusy()
                this.loading = false
            })
        },


        //----------------- Fungsi Pagination, Sorting, dan loading -----------------

        onLimitChange(){
            this.size = this.input.show
            this.perPage = this.input.show
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.getDataKeringanan()
        },

        onPageChange(){
            if (this.loading == false){
                this.page = this.currentPage - 1
                this.query = this.$helper.makeQuery(this.page, this.size)
                this.getDataKeringanan()
            }
        },

        sortingChanged(ctx) {
            if(ctx.sortBy != ""){
                this.input.sortBy = ctx.sortBy
                this.input.sortDesc = ctx.sortDesc
                this.onFilter()
            }
        },

        onReset(){
            this.input.filterNoFaktur = null
            this.input.filterNoAnggota = null
            this.input.filterStatus = null
            this.currentPage = 1
            this.page = 0
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataKeringanan()
        },

        onFilter(){
            this.page = 0
            this.currentPage = 1
            this.query = this.$helper.makeQuery(0, this.size)
            this.loading = true
            this.getDataKeringanan()
        },
        

        //----------------- Fungsi Pindah Halaman dan Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },

        updateTotalItem(total){
            let limit = null
            let prevLimit = null
            this.perPage = this.size
            this.rows = total
            prevLimit = this.page * this.size + 1
            limit = this.page * this.size + this.size
            if (limit > this.rows) limit = this.rows
            this.totalViewText = "Menampilkan "+ prevLimit + " - " + limit + " dari " + this.rows + " entri"
        }
    },

    created(){
        this.init()
        let flash = this.$helper.getFlash()
        if(flash != null) {
            this.$helper.toastSucc(this, flash)
        }
    }
}
</script>
